exports.periodList = ['Monthly', 'Quarterly', 'Yearly', 'Prepaid'];
exports.currencyList = ['CZK', 'EUR', 'USD', 'GBP'];
exports.connectivityList = ['NB-IoT 1MB', 'NB-IoT 60kB', 'LoRa CRa', 'Sigfox'];
exports.visualisationList = ['Grafana', 'Ubidots'];
exports.specialList = ['IoTBS'];
